import {
  jb_date_css_default
} from "./chunk.BNC7ZKWC.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-date/jb-date.ts
var JbDate = class extends r {
  render() {
    return ke`<time part="time"
      ><span>${this.date}</span>${this.time ? ke` <span>${this.time}</span>` : D}</time
    >`;
  }
};
JbDate.styles = jb_date_css_default;
__decorateClass([
  n()
], JbDate.prototype, "date", 2);
__decorateClass([
  n()
], JbDate.prototype, "time", 2);
JbDate = __decorateClass([
  customElement("jb-date")
], JbDate);

export {
  JbDate
};
